import Blank from "@/layouts/blank.vue";
import WorkloadList from "@/pages/admin/workload/WorkloadList.vue";

const workloadRoutes = [
  {
    path: "workload",
    name: "app-admin-workload",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/workload/list",
      },
      {
        path: "list",
        name: "app-admin-workload-list",
        component: WorkloadList,
      },
    ],
  },
];

export default workloadRoutes;
